import { Injectable } from '@angular/core';
import {
  TokenizeResult,
  TranslationMarkupRendererFactory,
  TranslationMarkupTranspiler,
  TranslationMarkupTranspilerContext,
  TranspileResult
} from 'ngx-transloco-markup';

export class LineBreakStart {}

export const LINE_BREAK_END = new (class LineBreakEnd {})();

@Injectable()
export class LineBreakTranspiler implements TranslationMarkupTranspiler {
  constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {}

  tokenize(translation: string, offset: number): TokenizeResult | undefined {
    return this.recognizeLineBreakStartToken(translation, offset) || this.recognizeLineBreakEndToken(translation, offset);
  }

  private recognizeLineBreakStartToken(translation: string, offset: number): TokenizeResult | undefined {
    const LINE_BREAK_START_TOKEN = '[br';

    if (!translation.startsWith(LINE_BREAK_START_TOKEN, offset)) {
      return undefined;
    }

    return {
      nextOffset: offset + LINE_BREAK_START_TOKEN.length,
      token: new LineBreakStart()
    };
  }

  private recognizeLineBreakEndToken(translation: string, offset: number): TokenizeResult | undefined {
    const EXTERNAL_LINK_END_TOKEN = '/]';

    if (!translation.startsWith(EXTERNAL_LINK_END_TOKEN, offset)) {
      return undefined;
    }

    return {
      nextOffset: offset + EXTERNAL_LINK_END_TOKEN.length,
      token: LINE_BREAK_END
    };
  }

  transpile(start: number, context: TranslationMarkupTranspilerContext): TranspileResult | undefined {
    const nextToken = context.tokens[start];

    if (!(nextToken instanceof LineBreakStart)) {
      return undefined;
    }

    const { nextOffset, renderers } = context.transpileUntil(start + 1, token => token === LINE_BREAK_END);

    return {
      nextOffset: Math.min(nextOffset + 1, context.tokens.length),
      renderer: this.rendererFactory.createElementRenderer('br', renderers)
    };
  }
}
